import { API_URLS } from "../constants";
import { getRequest, postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { SURVEY } = API_URLS;

//Saving survey
const addQuestion = (body, brandId) => {
  return postRequest(`${SURVEY.BASE}/${brandId}`, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
//Getting the survey against brandId
const getSurveyQuestions = (brandId) => {
  return postRequest(SURVEY.BASE, brandId).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response),
  );
};

//Getting survey recipients against brandId
const getSurveyRecipients = (brandId) => {
  return getRequest(`${SURVEY.GET_SURVEY_RECIPIENTS}/${brandId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response),
  );
};

//Updating survey recipients against brandId
const updateSurveyRecipients = (body, brandId) => {
  return postRequest(
    `${SURVEY.UPDATE_SURVEY_RECIPIENTS}/${brandId}`,
    body,
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response),
  );
};

export const surveyQuestionService = {
  addQuestion,
  getSurveyQuestions,
  getSurveyRecipients,
  updateSurveyRecipients,
};
